module.exports = __webpack_public_path__ + "img/maybe.8e0841e4.png";